<template>
<div class="mt-2">
    <!-- <v-toolbar flat color="white"> -->
    <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab>Devices</v-tab>
        <v-tab>Device Connections</v-tab>
        <v-tab>Models</v-tab>
        <v-tab>Makes</v-tab>
        <v-tab>Audit</v-tab>
    </v-tabs>
    <!-- </v-toolbar> -->
    <div class="mt-2">

    </div>
    <div v-if="tab==0">
        <devicecrud :devices="devices" :totalitems="devicesLength" :isloading="isLoading"></devicecrud>
    </div>
    <div v-else-if="tab==1">
        <deviceBridges></deviceBridges>
    </div>
    <div v-else-if="tab==2">
        <models></models>
    </div>
    <div v-else-if="tab==3">
        <deviceMakes></deviceMakes>
    </div>

     <div v-else-if="tab==4">
        <audit></audit>
    </div>

</div>
</template>

      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->

<script>
import Api from "@/services/Api";
import devices from "@/components/DeviceCrud.vue";
import deviceBridges from "@/components/DeviceBridges.vue";
import deviceMakes from "@/components/DeviceMakes.vue";
import models from "@/components/DeviceMakeModels.vue";
import audit from "@/components/DeviceAudit.vue";


export default {
    components: {
        devicecrud: devices,
        deviceBridges,
        deviceMakes,
        models,
        audit
    },
    watch: {
        '$route.query.search': {
            immediate: true,
            handler(value) {
                this.isLoading = true
                if (this.$route.query.search && value !== "" && value != null && this.$route.query.records && this.$route.query.offset) {
                    Api()
                        .get('/devices/active', {
                            params: {
                                search: value,
                                offset: '0',
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.devices = response.data.result
                            this.devicesLength = response.data.count
                            this.isLoading = false
                        })
                } else if (this.$route.query.offset && this.$route.query.records) {
                    // debugger
                    Api()
                        .get('/devices/active', {
                            params: {
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.devices = response.data.result
                            this.devicesLength = response.data.count
                            this.isLoading = false
                        })
                }
            }
        },
        '$route.query.offset': {
            immediate: true,
            handler(value) {
                this.isLoading = true
                if (this.$route.query.records && this.$route.query.offset && value !== "" && value != null && this.$route.query.search && this.$route.query.search != "" && this.$route.query.search !== null) {

                    Api()
                        .get('/devices/active', {
                            params: {
                                search: this.$route.query.search,
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.devices = response.data.result
                            this.devicesLength = response.data.count
                            this.isLoading = false
                        })
                } else if (value !== "" && value != null && this.$route.query.records) {
                    // debugger
                    Api()
                        .get('/devices/active', {
                            params: {
                                offset: this.$route.query.offset,
                                records: this.$route.query.records,
                            }
                        })
                        .then(response => {
                            this.devices = response.data.result
                            this.devicesLength = response.data.count
                            this.isLoading = false
                        })
                }
            },
        },
        tab(val) {
            console.log(val)
        }
    },
    data() {
        return {
            isLoading: true,
            devicesLength: [],
            devices: [],
            locationId: null,
            tab: 0
        };
    },
    computed: {},
    async created() {
        // this.setDeviceLength();
        let route = await this.$store.state.currentOrg.org.permissions.filter(function (el) {
            return el.url === '/devices'
        })
        if (route.length > 0) {
            await this.$store.dispatch("setCurrentRoute", route[0]);
            if (this.authRead(this.$store.state.currentRoute) === true) {
                this.initialize();
            }
        } else {
            this.$router.push({
                name: "SplashPage"
            });
        }
    },

    methods: {
        initialize() {
            this.$router.push({
                name: this.$route.name,
                query: {
                    offset: '0',
                    records: '20'
                }
            })
            // this.deviceCount()
            // this.fetchDevices();
        }
    }
};
</script>
